import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgX = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 78,
	height: 78,
	viewBox: "0 0 78 78",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("ellipse", {
		cx: 38.8243,
		cy: 38.8243,
		rx: 38.8243,
		ry: 38.8243,
		fill: "#1C1C1C"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M33.61 40.0881L19 22H30.5722L39.5908 33.1797L49.2259 22.0503H55.5992L42.6724 36.9996L58 56H46.4624L36.697 43.9099L26.2715 55.9665H19.8636L33.61 40.0881ZM48.144 52.6486L26.0957 25.3514H28.8892L50.9098 52.6486H48.144Z",
		fill: "white"
	})]
});
export default SvgX;
